<!--
 * @Author: your name
 * @Date: 2021-07-09 09:38:54
 * @LastEditTime: 2022-01-05 20:30:27
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\views\Home.vue
-->
<template>
  <div class="home">
    <div class="my-map-box">
      <MyMap ref="mapRef" @click-map="clickMap" />
    </div>
    <!-- 右下角列表 -->
    <labelLegend
      v-if="Object.values(labelLegendNumCount).length > 0"
      :numCount="labelLegendNumCount"
      :open="labelLegendState"
      @getSwitchState="hanleSwitchState"
      @getlabelLegend="hanleLabelLegend"
    ></labelLegend>
    <div class="home-content">
      <div class="home-left"></div>
      <home-left v-if="!labelLegendData[0].checked"></home-left>
      <home-right
        v-if="!labelLegendData[0].checked"
        @changeDefaultOpen="handleLabelLegend"
      ></home-right>
    </div>
    <!-- 搜索 -->
    <search
      v-model:equipemntType="mapNameLabel"
      :close="!labelLegendState"
      :nextSearch="true"
      @emitLocation="mapLocation"
      @emitRegionList="getRegionList"
    ></search>
    <!-- 摄像头搜索 -->
    <CramePage
      v-if="videoPointListSure && labelLegendData[0].checked"
      v-model:cameraList="videoPointListSure"
      @emitChangeVideoPoint="changeVideoPoint"
    ></CramePage>
    <!-- 摄像头动画 -->
    <mapVideo
      id="mapVideoDom"
      ref="mapVideoRef"
      :mapVideoData="mapVideoData"
    ></mapVideo>
    <mapArrayPoint
      id="mapArrayPointDom"
      ref="mapArrayPointRef"
      v-show="showArrayPointDom"
      :pointInfo="mapArrayPointData"
      @emitPointClick="getArrayPoint"
      @closeReminder="closeArrayPointDom"
    ></mapArrayPoint>

    <houseDialog
      v-model:visiable="dialogSate"
      v-if="dialogSate"
      :Id="houseId"
    ></houseDialog>

    <h-dialog
      class="FilingInfo"
      :title="companyDialogType == '1' ? '单位详情' : '设施详情'"
      v-model="dialogState"
      height="24vh"
      width="24vw"
      zIndex="100"
    >
      <companyDialog
        :itemInfo="companyDialogInfo"
        :itemType="companyDialogType"
        v-if="dialogState"
      ></companyDialog>
    </h-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  reactive,
  toRefs,
  watchEffect,
  ref,
  nextTick,
  onMounted,
  provide,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import { useContext, createContext } from "@/hooks/core/useContext.js";
import homeRight from "./Home/homeRight";
import homeLeft from "./Home/homeLeft";
import labelLegend from "./Home/labelLegend";
import CramePage from "./Home/CramePage";
import houseDialog from "./Home/houseDialog";
import companyDialog from "./Home/companyDialog";
import mapVideo from "./Home/mapVideo";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import {
  queryRealVideoTree,
  queryTreeAreaVideoAll,
} from "@/api/videoControl/videoApi.js";
import { securitylist } from "@/api/threeSolid/threeSolid.js";
import { unitList } from "@/api/threeSolid/fileManagement.js";
import util from "@util/js";
import {
  getUnitRegion,
  getHouseRegion,
  getPersonNumByRegion,
  getSecurityRegion,
} from "@/api/home/home.js";
import { ElMessage } from "element-plus";
export default {
  name: "Home",
  components: {
    MyMap,
    homeLeft,
    homeRight,
    labelLegend,
    CramePage,
    houseDialog,
    companyDialog,
    mapVideo,
  },
  setup() {
    const data = reactive({
      dialogSate: false,
      dialogState: false,
      labelLegendState: null,
      labelLegendNumCount: {
        // security: 0,
        // unit: 0,
        // house: 0,
        // video: 0,
      }, //右下角（）中数字
      labelLegendData: [
        {
          checked: false,
          name: "一标三实",
        },
        {
          checked: false,
          name: "监控设备",
        },
        {
          checked: true,
          name: "数据概览",
        },
      ],
      companyDialogInfo: {},
      companyDialogType: "1",
      unitPointList: [], //单位点位
      unitList: [], //单位列表
      housePointList: [],
      houseId: "", //点击点位获取点位对应房屋信息
      personPointList: [],
      securityList: [], //安防列表
      videoPointList: [], //所有摄像机信息
      videoPointListSure: null, //有点位信息摄像机信息
      showArrayPointDom: false,
      mapArrayPointData: [], //聚集点位弹窗详情
      mapVideoData: null, //摄像头点位信息  播放视频用
      mapVideoShow: 3, //摄像头点位组件是够展示在地图上
      mapNameLabel: "安防设施", //地图设备类型
    });
    const refData = toRefs(data);
    const mapRef = ref();
    const mapVideoRef = ref();
    const mapArrayPointRef = ref();
    const socket = useContext("socket");
    socket.on("connect", function (e) {
      console.log("e", e);
    });
    const { setPoint, reversePoint, setVideoPoint, reverseVideoPoint } =
      handleCoordinates();
    const regionInfo = reactive({
      regionList: [],
    });
    provide("region", regionInfo);
    const handleLabelLegend = (val) => {
      data.labelLegendState = val;
    };
    const hanleSwitchState = (val) => {
      data.labelLegendData = val;
      if (data.labelLegendData[0].checked) {
        hanleLabelLegend({ name: "监控设备" });
        data.labelLegendState = false;
      } else {
        hanleLabelLegend({ name: "安防设施" });
      }
    };
    const hanleLabelLegend = (val, obj) => {
      const { name = "安防设施" } = val;
      data.mapNameLabel = name;
      data.showArrayPointDom = false; //切换时关闭地图点位详情
      mapRef.value && mapRef.value.clearPoint();
      setTimeout(() => {
        if (name == "实有单位") {
          setTimeout(() => {
            pointInfoArray(data.unitList, 3404);
          }, 100);
        } else if (name == "实有房屋") {
          setTimeout(() => {
            pointInfoArray(data.housePointList, 3403);
          }, 100);
        } else if (name == "安防设施") {
          setTimeout(() => {
            pointInfoArray(data.securityList, 3405);
          }, 100);
        } else if (name == "监控设备") {
          setTimeout(() => {
            pointInfoArray(data.videoPointList, 3401, false);
          }, 100);
        }
      }, 100);
    };
    //
    const changeVideoPoint = (val) => {
      if (val.checked) {
        nextTick(() => {
          mapVideoRef.value && mapVideoRef.value.close();
          mapRef.value && mapRef.value.delPoint(val.list);
        });
      } else {
        nextTick(() => {
          mapRef.value && mapRef.value.loadMarker(val.list);
        });
      }
    };
    const getRegionList = (val) => {
      regionInfo.regionList = val;
      data.labelLegendNumCount = {};
      mapRef.value && mapRef.value.clearPoint();
      getRegionAsync();
    };
    //添加接口中数据点位
    //zg表示走紫光数据接口，跟我们的数据结构不一致需要单独处理
    const pointInfoArray = (list, typeValue, zg = true) => {
      let array;
      if (zg) {
        array = list.filter((item) => {
          if (item.regionInfo.longitude && item.regionInfo.latitude) {
            return item;
          }
        });
      } else {
        array = list.filter((item) => {
          if (item.longitude && item.latitude) {
            item.location = setVideoPoint([
              Number(item.longitude),
              Number(item.latitude),
            ]);

            return item;
          }
        });
      }
      let newList = array.map((element, index) => {
        let pointInfo = {
          name:
            element.securityName ||
            element.name ||
            element.cameraName ||
            element.unitName,
          item: element,
          id: 1,
          type: 1,
          poiType: typeValue,
          showType: 1,
          location: [],
          click: (e) => {
            data.showArrayPointDom = false;
            if (e.length > 1) {
              handleMapArrayClick(e);
              nextTick(() => {
                data.mapArrayPointData = e;
              });
            } else {
              handleMapIconClick(e);
              nextTick(() => {
                data.mapDataItem = element;
                data.mapVideoData = e;
              });
            }
          },
        };

        pointInfo.id = index + 1;
        if (zg) {
          pointInfo.location[0] = parseFloat(element.regionInfo.longitude);
          pointInfo.location[1] = parseFloat(element.regionInfo.latitude);
        } else {
          pointInfo.location = element.location;
        }
        return pointInfo;
      });
      if (!zg) {
        data.videoPointListSure = newList;
      }
      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker(newList);
      });
    };
    const mapLocation = (val) => {
      mapRef.value &&
        mapRef.value.mapLocation(
          data.mapNameLabel == "监控设备"
            ? setVideoPoint(val.location)
            : val.location,
          val.zoom
        );
    };
    // 展示点位详情
    const handleMapIconClick = (e) => {
      if (e[0].values_.poiType == 3401) {
        const dom = document.getElementById("mapVideoDom");
        const pos = e[0].values_.location;
        const drawOption = {
          positioning: "top-left",
          offset: [0, -20],
          stopEvent: false,
        };

        mapRef.value && mapRef.value.drawPointInfo(dom, pos, drawOption);
        data.mapVideoShow = 1;
      } else if (e[0].values_.poiType == 3405) {
        data.companyDialogType = "2";
        //安防设施
        let parmas = data.securityList.filter((item) => {
          return item.regionId == e[0].values_.item.regionId;
        });
        open2Dialog(parmas);
      } else if (e[0].values_.poiType == 3403) {
        //时有房屋
        openDialog(e[0].values_.item.id);
      } else if (e[0].values_.poiType == 3404) {
        //时有单位
        data.companyDialogType = "1";
        let parmas = data.unitList.filter((item) => {
          return item.unitId == e[0].values_.item.unitId;
        });
        open2Dialog(parmas);
        // if (data.unitList) {
        //   let parmas = getDialogData(data.unitList, e[0].values_.item);
        //   if (parmas.length == 0) {
        //     ElMessage.warning("暂无点位信息");
        //   } else {
        //     console.log(parmas, 9999999);
        //     open2Dialog(parmas);
        //   }
        // }
      }
    };
    //聚合点列表点击展示弹框
    const getArrayPoint = (val) => {
      //需要对传过来啊的值做一层包裹适用handleMapIconClick方法
      const e = {
        values_: val,
      };
      if (val.poiType == 3401) {
        mapRef.value && mapRef.value.mapLocation(val.location, 18);
        closeArrayPointDom();
      }
      handleMapIconClick([e]);
      data.mapVideoData = [e];
    };
    //展示多个点位详情
    const handleMapArrayClick = (e) => {
      data.showArrayPointDom = true;
      const dom = document.getElementById("mapArrayPointDom");
      let pos = e[0].values_.location;
      let drawOption = {
        positioning: "bottom-center",
        offset: [0, -30],
        stopEvent: false,
      };
      mapRef.value && mapRef.value.drawPointInfo(dom, pos, drawOption);
    };
    //关闭多个点位详情
    const closeArrayPointDom = () => {
      data.showArrayPointDom = false;
    };
    //单位、设备弹框
    const open2Dialog = (value) => {
      data.companyDialogInfo = value;
      nextTick(() => {
        data.dialogState = true;
      });
    };
    //房屋弹框
    const openDialog = (value) => {
      data.houseId = value;
      data.dialogSate = true;
    };
    //地图点击
    const clickMap = () => {
      if (data.labelLegendData[0].checked && data.mapVideoShow == 1) {
        mapVideoRef.value && mapVideoRef.value.change();
      }
      if (data.mapVideoShow != 1) {
        mapVideoRef.value && mapVideoRef.value.close();
      }
      data.mapVideoShow++;
    };
    //地图点位接口
    //房屋楼栋先查区域再匹配ID
    //安防直接查list
    const getRegionAsync = async () => {
      const parms = {
        unit: { type: 4, regionIds: regionInfo.regionList.toString() },
        house: { type: 4, regionIds: regionInfo.regionList.toString() },
        person: { type: 0, regionIds: regionInfo.regionList.toString() },
        security: { regionIds: regionInfo.regionList.toString() },
        video: {
          regionIds:
            regionInfo.regionList.length > 0 ? regionInfo.regionList : null,
        },
      };
      // 单位点位接口
      // const resUnit = await getUnitRegion(parms.unit);
      const unitData = await unitList(parms.unit);
      //房屋点位接口
      const resHouse = await getHouseRegion(parms.house);
      // 重点人员点位接口
      const resPerson = await getPersonNumByRegion(parms.person);
      //安防设备点位接口
      const securityData = await securitylist(parms.security);
      //监控设备点位
      const resVideo = await queryTreeAreaVideoAll(parms.video);

      if (unitData.code == 0) {
        data.unitList = unitData.page.list;
        data.labelLegendNumCount.unit = unitData.page.list.length;
      }
      if (resHouse.code == 0) {
        data.housePointList = resHouse.data;
        data.labelLegendNumCount.house = resHouse.data.length;
      }
      if (resPerson.code == 0) {
        data.personPointList = resPerson.data;
      }
      if (securityData.code == 0) {
        data.securityList = securityData.page.list;
        data.labelLegendNumCount.security = securityData.page.list.length;
      }
      if (resVideo.code == 0) {
        data.videoPointList = resVideo.cameraBaseDtls;
        let i = 0;
        resVideo.cameraBaseDtls.forEach((item) => {
          if (item.longitude && item.latitude) {
            i++;
          }
        });
        data.labelLegendNumCount.video = i;
      }
      // hanleLabelLegend();
      hanleLabelLegend({ name: "安防设施" });
    };

    getRegionAsync();
    return {
      ...refData,
      mapRef,
      mapVideoRef,
      mapArrayPointRef,
      changeVideoPoint,
      closeArrayPointDom,
      handleLabelLegend,
      hanleSwitchState,
      hanleLabelLegend,
      getArrayPoint,
      clickMap,
      mapLocation,
      getRegionList,
    };
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  width: 100%;
  position: relative;
  .my-map-box {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
  .home-content {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    pointer-events: none;
    display: flex;

    .home-left {
      pointer-events: auto;
    }
  }
}
</style>
